
import axios from 'axios';
import { getServerError } from '../error/error-service';
import {
    GetIssueAverageAgeReportParams,
    GetIssueCreatedAndResolvedTaskComparisonReportParams,
    GetIssueDecisionTimeReportParams,
    GetIssuePieChartByAssigneeReportParams,
    GetIssuePlanVsFactReportParams, GetIssueRecentlyCreatedReportParams, GetIssueStatisticOnWorkersReportParams, GetIssueTimeSpentReportParams, GetIssueUploadingUsersReportParams, GetPersonalWorkReportByIssueParams, IssueAverageAgeReportResult, IssueCreatedAndResolvedTaskComparisonReportResult, IssueDecisionTimeReportResult, IssuePieChartByAssigneeReportResult, IssuePlanVsFactReportResult, IssueStatisticOnWorkersReportResult, IssueTimeSpentReportResult, IssueUploadingUsersReportResult, PersonalWorkReportByIssueResult, RecentlyCreatedReportRow,
} from './analytics-service.types';

const DocApiBaseUrl = `/doc-api`;

export const getIssueRecentlyCreatedReport = (params: GetIssueRecentlyCreatedReportParams) => {
    return axios.get<RecentlyCreatedReportRow[]>(`${DocApiBaseUrl}/analytic/recently-created-issues`, { params })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);

        });
}

export const getIssuePlanVsFactReport = (params: GetIssuePlanVsFactReportParams) => {
    return axios.get<IssuePlanVsFactReportResult[]>(`${DocApiBaseUrl}/analytic/issue-plan-vs-fact`, { params })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);

        });
}

export const getIssueAverageAgeReport = (params: GetIssueAverageAgeReportParams) => {
    return axios.get<IssueAverageAgeReportResult[]>(`${DocApiBaseUrl}/analytic/issue-average-age`, { params })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);

        });
}

export const getIssuePieChartByAssigneeReport = (params: GetIssuePieChartByAssigneeReportParams) => {
    return axios.get<IssuePieChartByAssigneeReportResult[]>(`${DocApiBaseUrl}/analytic/issue-pie-chart-by-assignee`, { params })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);

        });
}

export const getIssueDecisionTimeReport = (params: GetIssueDecisionTimeReportParams) => {
    return axios.get<IssueDecisionTimeReportResult[]>(`${DocApiBaseUrl}/analytic/issue-decision-time-report`, { params })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);

        });
}

export const getIssueCreatedAndResolvedTaskComparisonReport = (params: GetIssueCreatedAndResolvedTaskComparisonReportParams) => {
    return axios.get<IssueCreatedAndResolvedTaskComparisonReportResult[]>(`${DocApiBaseUrl}/analytic/issue-created-and-resolved-task-comparison-report`, { params })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);

        });
}

export const getIssueUploadingUsersReport = (params: GetIssueUploadingUsersReportParams) => {
    return axios.get<IssueUploadingUsersReportResult>(`${DocApiBaseUrl}/analytic/issue-uploading-users-report`, { params })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);

        });
}

export const getIssueTimeSpentReport = (params: GetIssueTimeSpentReportParams) => {
    return axios.get<IssueTimeSpentReportResult[]>(`${DocApiBaseUrl}/analytic/issue-time-spent-report`, { params })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);

        });
}

export const getPersonalWorkReportByIssue = (params: GetPersonalWorkReportByIssueParams) => {
    return axios.get<PersonalWorkReportByIssueResult>(`${DocApiBaseUrl}/analytic/personal-work-report-by-issue`, { params })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);

        });
}

export const getIssueStatisticOnWorkersReport = (params: GetIssueStatisticOnWorkersReportParams) => {
    return axios.get<IssueStatisticOnWorkersReportResult>(`${DocApiBaseUrl}/analytic/issue-statistic-on-workers-report`, { params })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);

        });
}
